export enum FeatureFlag {
  ALLOW_OSV_DIRECT_SALES = 'allow-osv-direct-sales',
};

export enum PolicyEffect {
  'ExplicitAllow',
  'ExplicitDeny',
  'ImplicitAllow',
  'ImplicitDeny'
};